
import { useState } from "react";
import { useContext } from "react";
import { AuthContext } from "../../context/auth.context";
import { useNavigate } from "react-router-dom";
import authService from "../../services/auth.service";
import { toast } from "react-toastify";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";
import EmailIcon from "@mui/icons-material/Email";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import WorkIcon from "@mui/icons-material/Work";
import AccountCircle from "@mui/icons-material/AccountCircle";

import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import { useTranslation } from "react-i18next";
import enTranslations from "../../en.json";
import arTranslations from "../../ar.json";

i18n.use(initReactI18next).init({
  resources: {
    en: { translation: enTranslations },
    ar: { translation: arTranslations },
  },
  lng: "en",
  fallbackLng: "en",
  interpolation: { escapeValue: false },
});
function Profile() {
  const { isLoggedIn, user, logOutUser, setUser } = useContext(AuthContext);

  // const [errorMessage, setErrorMessage] = useState(undefined);

  const [newEmail, setnewEmail] = useState(user.email);
  const [newPassword, setnewPassword] = useState("");
  const [oldPassword, setOldPassword] = useState("");
  const [newUsername, setnewUsername] = useState(user.username);
  const [showConfirmationDialog, setShowConfirmationDialog] = useState(false);
  const [showPassword, setShowPassword] = useState(false);


  const navigate = useNavigate();
  const { t } = useTranslation();

  const handleChangeEmail = (e) => setnewEmail(e.target.value);
  const handleChangeUsername = (e) => setnewUsername(e.target.value);
  const handleChangePassword = (e) => setnewPassword(e.target.value);
  const handleChangeOldPassword = (e) => setOldPassword(e.target.value);
  const handleCheckboxChange = (e) => setShowPassword(e.target.checked);

  const handleChangeProfilSubmit = (e) => {
    e.preventDefault();
    const requestBody = { newEmail, newPassword, newUsername, oldPassword };
    authService
      .edit(requestBody)
      .then((response) => {
        // If the POST request is successful redirect to the login page
        setUser(response.data);
        if (user.email !== newEmail) {
          toast.success("email updated");
        }
        if (user.username !== newUsername) {
          toast.success("username updated");
        }
        if (newPassword) {
          toast.success("password updated");
        }
      })
      .catch((error) => {
        // If the request resolves with an error, set the error message in the state
        const errorDescription = error.response.data.message;
        toast.error(errorDescription);
      });
  };
  const handleDeleteProfilSubmit = (e) => {
    e.preventDefault();
    setShowConfirmationDialog(true);
  };
  const handleDeleteConfirmed = () => {
    authService
      .delete()
      .then((response) => {
        logOutUser();
        toast.success("Profile deleted");
        // If the Delete request is successful redirect to the home page
        navigate("/");
      })
      .catch((error) => {
        // If the request resolves with an error, set the error message in the state
        const errorDescription = error.response.data.message;
        toast.error(errorDescription);
      });
    setShowConfirmationDialog(false);
  };
  const handleDeleteCancelled = () => {
    setShowConfirmationDialog(false);
  };

  return (
    <div className="Global-profile">
      <div className="px-4 py-16 mx-auto sm:max-w-xl md:max-w-full lg:max-w-screen-xl md:px-24 lg:px-8 lg:py-20">
        <div className="max-w-screen-xl sm:mx-auto ">
          <div className="grid grid-cols-1 gap-8 row-gap-4 lg:grid-cols-2">
            <form onSubmit={handleChangeProfilSubmit}>
              <Box
                className="flex justify-center"
                sx={{
                  display: "flex",
                  alignItems: "center",
                  "& > :not(style)": { m: 1 },
                }}
              >
                <TextField
                  className="w-80 "
                  InputLabelProps={{
                    style: { fontSize: 19, color: "#6495ED" },
                  }}
                  helperText=""
                  label={t("username")}
                  defaultValue={newUsername}
                  type="text"
                  name="newUsername"
                  onChange={handleChangeUsername}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <AccountCircle style={{ color: "#6495ED" }} />
                      </InputAdornment>
                    ),
                    style: { fontSize: 17, fontWeight: 450, fontStyle: "bold" },
                  }}
                />
              </Box>
              <Box
                className="flex justify-center"
                sx={{
                  display: "flex",
                  alignItems: "center",
                  "& > :not(style)": { m: 1 },
                }}
              >
                <TextField
                  className="w-80"
                  InputLabelProps={{
                    style: { fontSize: 19, color: "#6495ED" },
                  }}
                  helperText=""
                  id="Email"
                  label={t("email")}
                  type="email"
                  name="newEmail"
                  value={newEmail}
                  onChange={handleChangeEmail}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <EmailIcon style={{ color: "#6495ED" }} />
                      </InputAdornment>
                    ),
                    style: { fontSize: 17, fontWeight: 450, fontStyle: "bold" },
                  }}
                />
              </Box>
              <Box
                className="flex justify-center"
                sx={{
                  display: "flex",
                  alignItems: "center",
                  "& > :not(style)": { m: 1 },
                }}
              >
                <TextField
                  className="w-80 "
                  InputLabelProps={{
                    style: { fontSize: 19, color: "#6495ED" },
                  }}
                  helperText=""
                  label={t("currentpassword")}
                  value={oldPassword}
                  type={showPassword ? 'text' : 'password'}
                  name="oldPassword"
                  onChange={handleChangeOldPassword}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <AccountCircle style={{ color: "#6495ED" }} />
                      </InputAdornment>
                    ),
                    style: { fontSize: 17, fontWeight: 450, fontStyle: "bold" },
                  }}
                />
              </Box>

              <Box
                className="flex justify-center"
                sx={{
                  display: "flex",
                  alignItems: "center",
                  "& > :not(style)": { m: 1 },
                }}
              >
                <TextField
                  className="w-80 "
                  InputLabelProps={{
                    style: { fontSize: 19, color: "#6495ED" },
                  }}
                  helperText=""
                  value={newPassword}
                  label={t("newpassword")}
                  type={showPassword ? 'text' : 'password'}
                  name="newPassword"
                  onChange={handleChangePassword}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <AccountCircle style={{ color: "#6495ED" }} />
                      </InputAdornment>
                    ),
                    style: { fontSize: 17, fontWeight: 450, fontStyle: "bold" },
                  }}
                />
              </Box>
              <FormControlLabel
              control={
                <Checkbox
                  checked={showPassword}
                  onChange={handleCheckboxChange}
                  color="primary"
                />
              }
              label={t("showpassword")}
            />
              {/* <Box
                className="flex justify-center"
                sx={{
                  display: "flex",
                  alignItems: "center",
                  "& > :not(style)": { m: 1 },
                }}
              > */}
                {/* <TextField
                  multiline={true}
                  rows={8}
                  className=" w-80   "
                  InputLabelProps={{
                    style: { fontSize: 19, color: "#6495ED" },
                  }}
                  helperText=""
                  label="Bio"
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <WorkIcon style={{ color: "#6495ED" }} />
                      </InputAdornment>
                    ),
                    style: { fontSize: 17, fontWeight: 450, fontStyle: "bold" },
                  }}
                /> */}
            {/* /  </Box> */}
              <button className=" button-profile  button-profile-save button-71" type="submit">
                {t("save")}
              </button>
            </form>
            <button className="button-profile button-profile-delete" onClick={handleDeleteProfilSubmit}>
              {t("deleteprofile")}
            </button>
            <Dialog open={showConfirmationDialog}>
              <DialogTitle>Confirm Delete Profile</DialogTitle>
              <DialogContent>
                <p>{t("paragraph5")}</p>
                <p>{t("paragraph6")}</p>
              </DialogContent>
              <DialogActions>
                <Button onClick={handleDeleteCancelled}>{t("cancel")}</Button>
                <Button onClick={handleDeleteConfirmed} autoFocus>
                  {t("deleteprofile")}
                </Button>
              </DialogActions>
            </Dialog>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Profile;
